// src/pages/Admin/ReferralList.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

export default function ReferralList() {
  const { referCode } = useParams();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReferrals = async () => {
      try {
        const res = await axios.get(`https://api.earnmoney0.top/api/admin/referrals/${referCode}`);
        if (res.data.success) {
          // Calculate withdrawBalance for each user
          const usersWithWithdraw = await Promise.all(
            res.data.users.map(async (user) => {
              try {
                const userInfoRes = await axios.get(`https://api.earnmoney0.top/api/admin/user-info/${user.phone}`);
                if (userInfoRes.data.success) {
                  return { ...user, withdrawBalance: userInfoRes.data.user.withdrawBalance };
                }
                return { ...user, withdrawBalance: 0 };
              } catch {
                return { ...user, withdrawBalance: 0 };
              }
            })
          );
          setUsers(usersWithWithdraw);
        }
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };

    fetchReferrals();
  }, [referCode]);

  const toggleStatus = async (userId, status) => {
    try {
      const res = await axios.put(`https://api.earnmoney0.top/api/admin/user-status/${userId}`, { status });
      if (res.data.success && res.data.user) {
        setUsers(prev =>
          prev.map(u => (u.id === userId ? { ...u, accountStatus: res.data.user.accountStatus } : u))
        );

        // ✅ Notification
        const msg = document.createElement("div");
        msg.textContent =
          status.toLowerCase() === "active"
            ? "✅ User Activated Successfully!"
            : "🚫 User Suspended Successfully!";
        msg.style.cssText =
          "position:fixed;top:20px;right:20px;padding:10px 18px;font-weight:600;border-radius:8px;box-shadow:0 0 15px rgba(0,0,0,0.5);z-index:9999;" +
          (status.toLowerCase() === "active" ? "background:#4ade80;color:#0b0f1a;" : "background:#f87171;color:#0b0f1a;");
        document.body.appendChild(msg);
        setTimeout(() => msg.remove(), 2000);
      }
    } catch (err) {
      console.error(err);
      alert("⚠️ Something went wrong!");
    }
  };

  if (loading)
    return (
      <div style={{ padding: 24, color: "white", backgroundColor: "#0b0f1a", minHeight: "100vh" }}>
        <p>Loading...</p>
      </div>
    );

  return (
    <div className="referral-list-page">
      <style>{`
        .referral-list-page {
          min-height: 100vh;
          background-color: #0b0f1a;
          color: white;
          padding: 24px;
          font-family: sans-serif;
        }
        h1 {
          color: #22c55e;
          margin-bottom: 24px;
        }
        .referral-table {
          width: 100%;
          border-collapse: collapse;
        }
        .referral-table th,
        .referral-table td {
          padding: 12px 8px;
          border: 1px solid #333;
          text-align: left;
        }
        .referral-table th {
          background-color: #111827;
          color: #fff;
          font-weight: 600;
        }
        .referral-table tr:nth-child(even) {
          background-color: #1f2937;
        }
        .status-btn {
          padding: 6px 12px;
          border-radius: 6px;
          font-weight: 600;
          cursor: pointer;
          margin-right: 6px;
          border: none;
        }
        .status-active {
          background-color: #22c55e;
          color: black;
        }
        .status-suspended {
          background-color: #ef4444;
          color: white;
        }
      `}</style>

      <h1>Referrals for Code: {referCode}</h1>

      <table className="referral-table">
        <thead>
          <tr>
            <th>Username</th>
            <th>Phone</th>
            <th>Deposit Balance</th>
            <th>Withdraw Balance</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u.id}>
              <td>{u.username}</td>
              <td>{u.phone}</td>
              <td>৳{u.depositBalance}</td>
              <td>৳{u.withdrawBalance || 0}</td>
              <td>
                <button
                  className={`status-btn ${u.accountStatus === "Active" ? "status-active" : ""}`}
                  onClick={() => toggleStatus(u.id, "active")}
                >
                  Active
                </button>
                <button
                  className={`status-btn ${u.accountStatus === "Suspended" ? "status-suspended" : ""}`}
                  onClick={() => toggleStatus(u.id, "suspended")}
                >
                  Suspended
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}